
import Component from "vue-class-component";
import Vue from "vue";
import BarcodeSystemModule  from "@/store/modules/barcodeSystem";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";
import { ReturnReasonCodeResource } from "../../models/api/barcodeSystem/returnReasonCode";
import { EditReturnReasonModel } from "@/models/ui/editReturnReason";
import { formatBool } from "@/utils";

const barcodeSystemModuleState = getModule(BarcodeSystemModule);
import notifications from "../../lib/notifications";
@Component({
  components: {
    Select
  }
})
export default class ReturnReasons extends Vue {
  returnReasons: ReturnReasonCodeResource[] = null;
  returnReasonFilter: string = null;
  loading: boolean = false;
  editReturnReasonModel: EditReturnReasonModel = null;

  async created() {
    await this.loadReturnReasons();
  }

  async loadReturnReasons() {
    this.loading = true;
    await barcodeSystemModuleState.loadReturnReasonCodes();
    this.returnReasons = barcodeSystemModuleState.returnReasonCodes;
    this.loading = false;
  }

  get filteredReturnReasons() {
    if(this.returnReasonFilter)
      return this.returnReasons.filter(x =>(x.description && x.description.toUpperCase().startsWith(this.returnReasonFilter.toUpperCase()) || 
                                           x.code.toUpperCase().startsWith(this.returnReasonFilter.toUpperCase())));
    else
      return this.returnReasons;
  }

  formatBool(val: string)
  {
    return formatBool(val);
  }

  descriptionState() {
    return this.editReturnReasonModel.description ? null : false;
  }

  codeState() {
    return this.editReturnReasonModel.code ? null : false;
  }

  validateForm() {
    if(this.descriptionState() === false) return false;
    if(this.codeState() === false) return false;
    return true;
  }

  goBack() {
    this.$router.back();
  }

  async saveReturnReason() {
    if(!this.validateForm()) return;
    try {
      this.editReturnReasonModel.saving = true;
      if (this.editReturnReasonModel.isNew) {
        await barcodeSystemModuleState.createReturnReason(this.editReturnReasonModel.toCreateReturnReasonRequest());
      } else {
        await barcodeSystemModuleState.updateReturnReason(this.editReturnReasonModel.toUpdateReturnReasonRequest());
      }
      notifications.success("Return Reason Saved", "Successfully saved return reason");
      await this.loadReturnReasons();
      this.closeEditModal();
    } catch (ex) {
      notifications.error("Save Return Reason", "Failed to save return reason", ex);
      this.editReturnReasonModel.saving = false;
    }
  }  
  
  closeEditModal() {
    this.editReturnReasonModel.visible = false;
    this.editReturnReasonModel = null;
  }

  async editReturnReason(item: ReturnReasonCodeResource = null) {
    this.editReturnReasonModel = new EditReturnReasonModel();
    this.editReturnReasonModel.visible = true;

    if (item) {
      const returnReason = await barcodeSystemModuleState.getReturnReasonCode(item.code);
      this.editReturnReasonModel.loading = false;
      this.editReturnReasonModel.isNew = false;
      this.$set(this.editReturnReasonModel, 'code', returnReason.code);
      this.$set(this.editReturnReasonModel, 'description', returnReason.description);
    } else {
      this.editReturnReasonModel.showForNewReturnReason();
    }
  }
}
